const initialStateAuth = {
    user: null,
    estadoUsuario: "buscando", // "buscando", "activo", "fuera", "error"
    loading: false,
    error: null
}

const reducerAuth = (state, action) => {
    switch (action.type) {
        case "setAuth":
            return { 
                ...state, 
                user: action.payload,
                loading: false,
                error: null,
                estadoUsuario: action.payload ? "activo" : "fuera"
            }
        
        case "setEstadoUsuario":
            return { ...state, estadoUsuario: action.payload }
        
        case "setLoading":
            return { ...state, loading: action.payload }
        
        case "setError":
            return { ...state, error: action.payload, loading: false }
        
        case "clearError":
            return { ...state, error: null }
        
        case "resetAuth":
            return {
                ...initialStateAuth,
                user: null,
                estadoUsuario: "fuera"
            }
        
        default:
            return state
    }
}

export { initialStateAuth }
export default reducerAuth